import axios from "axios";

/**
 * API-Basis-URL auflösen.
 *
 * Strategie:
 * 1) Im Browser (z. B. nutri-calc.org oder recipe-analyzer-8.emergent.host) wird
 *    IMMER die Domain genutzt, von der die App geladen wurde — also `window.location.origin`.
 *    Dadurch funktionieren beide URLs gleichwertig, auch wenn Firewalls eine davon
 *    blockieren (Sophos blockt z. B. nutri-calc.org → der User nutzt einfach
 *    recipe-analyzer-8.emergent.host).
 *
 * 2) Bei Server-Side Rendering / Build oder wenn explizit ein Override gewünscht ist,
 *    fällt der Code auf process.env.REACT_APP_BACKEND_URL zurück.
 */
function resolveBackendBase() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

export const BASE = resolveBackendBase();
export const API = `${BASE}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nc_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Bei 402 (Trial abgelaufen) Window-Event feuern, damit AuthContext den User-Status neu lädt
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 402) {
      try {
        window.dispatchEvent(new CustomEvent("nc:trial-expired"));
      } catch {
        // ignore
      }
    }
    return Promise.reject(err);
  }
);

export default api;
